import React, { useState } from 'react';

import CreateZoneDrawer from '../CreateZoneDrawer';
import Button from 'components/Button';

import Add from "assets/images/icons/JSX/Add";

const CreateCoolingZone = ({ type = "", className, change, displayUnits }) => {
    const [isOpen, setIsOpen] = useState(false);

    const handleOpenCreate = () => {
        setIsOpen(true);
    };

    const handleCloseDrawer = () => {
        setIsOpen(false);
    };

    return (
        <div className={`${className}`}>
            <Button
                icon={Add}
                type={type}
                onClick={handleOpenCreate}
                smallPadding
            >
                Create Cooling Zone
            </Button>
            <CreateZoneDrawer
                isOpen={isOpen}
                onClose={handleCloseDrawer}
                change={change}
                displayUnits={displayUnits}
            />
        </div>
    )
};

export default CreateCoolingZone;